<template>
  <div style="display: grid;">
    <div class="mb-2" style="margin-left: -24px;">
      <ul class="step-menu">
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Customer Information</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Consignee / Shipper</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Billing Information</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">4</div>
          <div>Required Documents</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">5</div>
          <div>Additional</div>
        </li>
      </ul>
    </div>
    <div class="scroller mt-4">
      <div class="__wraper_">
        <div class="_address">
          <div v-if="isLoadingAddressList" class="_documents__container">
            <half-circle-spinner
              :animation-duration="1000"
              :size="60"
              color="#ff1d5e"
            />
          </div>
          <div v-else :class="!addressList ? 'd-flex align-items-center' : ''">
            <div v-if="addressList">
              <AddressCard :currentPage="currentPage" :mode="'setting'" :isFiltering="isFiltering" />
            </div>
            <div v-else>
              <p class="mr-2" style="font-style: italic;">You have no billing address.</p>
            </div>
            <div class="row m-0 paginationCustom pt-3">
              <div class="col-md-12 d-flex justify-content-center">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                >
                </b-pagination>
              </div>
            </div>
            <!-- <button class="btn button-grey mt-2" @click="toFormAddress">
              Add Billing
            </button> -->
            <button class="button__bluecorporite mt-2" @click="toFormAddress">
              Add Billing Address
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center mr-4">
          <button class="btn btn-white-blue mr-2" @click="onSelectedTabBack">Back</button>
          <div class="btn btn-white-blue mr-2" @click="saveDraft">Save Draft</div>
          <button class="btn btn-white-blue" @click="onSelectedTab">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import AddressCard from '@/components/settings/AddressCard.vue'
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'form3',
  components: {
    Sidebar,
    AddressCard,
    HalfCircleSpinner
  },
  data () {
    return {
      dataAddress: [],
      currentPage: 1,
      totalRows: 0,
      globalBillingData: '',
      perPage: 4
    }
  },
  computed: {
    ...mapGetters({
      addressList: 'address/addressList',
      isLoadingAddressList: 'address/isLoadingAddressList',
      addressListFilter: 'address/addressListFilter',
      billingAddressGlobal: 'address/billingAddressGlobal'
    })
  },
  mounted () {
    this.fetchAddressList()
  },
  created () {
    this.$eventHub.$on('fetch-all-address', this.fetchAddressList())
  },
  beforeDestroy () {
    this.$eventHub.$off('fetch-all-address')
  },
  watch: {
    addressList (data) {
      if (data) {
        this.totalRows = data.totalRecords
      }
    },
    currentPage (data) {
      if (data) {
        this.fetchAddressList()
      }
    }
  },
  methods: {
    async fetchAddressList () {
      this.isFiltering = false
      await this.$store.dispatch('address/FETCH_ALL_ADDRESS', {page: this.currentPage, perPage: this.perPage})
    },
    async toFormAddress () {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
      this.$eventHub.$emit('dialog-form-address', {title: 'Add Address', currentPage: this.currentPage})
    },
    onSelectedTab () {
      this.$emit('Next', 'form4')
    },
    onSelectedTabBack () {
      this.$emit('Back', 'form2')
    },
    saveDraft () {
      this.$emit('Draft', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/saf/form3.vue